var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-12",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }